import React from "react";
import "./Guidelines.css";

export default function GuidelinesPage() {
  return (
    <div className="guidelines-container">
      <h1 className="guidelines-title">Review Guidelines</h1>

      <section className="guideline-section">
        <h2>🍽️ Tier Definitions</h2>
        <ul>
          <li><strong>Tier 1 (Gold)</strong>: The best of the best—the best of a cuisine, the best of a region, exceptional quality</li>
          <li><strong>Tier 2 (Silver)</strong>: High-quality restaurants that aren't quite the best, but still meet high standards</li>
          <li><strong>Tier 3 (Bronze)</strong>: Very good, but lacking in some way that holds it back</li>
          <li><strong>Tier 4</strong>: Interesting recommended places I have tried</li>
        </ul>
      </section>

      <section className="guideline-section">
        <h2>💵 Price Guide (CAD)</h2>
        <ul>
          <li><strong>$</strong>: $0-$30 per person</li>
          <li><strong>$$</strong>: $30-$60 per person</li>
          <li><strong>$$$</strong>: $60-$130 per person</li>
          <li><strong>$$$$</strong>: $130-$200 per person</li>
          <li><strong>$$$$$</strong>: $200+ per person</li>
        </ul>
      </section>
    </div>
  );
}
